<template>
  <div class="content">
    <PageHeader title="Feriados" />
    <div class="page-content container-fluid">
      <div class="card">
        <div class="card-header">
          <router-link
            to="/live/configs/holidays/create"
            class="btn btn-success float-right"
            tag="button"
          >
            <i class="fas fa-plus color-white"></i>
            <span class="hide-mobile">Adicionar feriado</span>
          </router-link>
        </div>
        <div class="card-body p-0">
          <div class="static qt-block-ui p-2" v-if="loading"></div>
          <div class="p-4" v-else-if="!holidays || !holidays.length">
            <div class="text-center table-placeholder">
              <i class="fas fa-calendar-check fa-fw font-size-80"></i>
              <h5 class="card-title m-t-20">
                Não há feriados cadastrados
              </h5>
            </div>
          </div>
          <template v-else>
            <table class="table">
              <thead class="bg-light">
                <tr>
                  <!-- <th class="p-l-20">ID</th> -->
                  <th>Titulo</th>
                  <th class="p-l-20">Começa</th>
                  <th class="p-l-20">Termina</th>
                  <th class="p-l-20"></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(holiday, i) in holidays">
                  <tr role="button" :key="holiday.id">
                    <!-- <td>{{holiday.id}}</td> -->
                    <td>{{holiday.name}}</td>
                    <td>{{holiday.date_begin | date('DD/MM/YYYY HH:mm:ss')}}</td>
                    <td>{{holiday.date_end| date('DD/MM/YYYY HH:mm:ss')}}</td>
                    <td>
                      <div class="dropdown">
                        <a
                          role="button"
                          class="dropdown-action"
                          :to="'#menu-dropdown-' + i"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="icon dripicons-gear text-success"></i>
                        </a>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          :id="'menu-dropdown-' + i"
                          x-placement="bottom-end"
                          style
                        >
                          <!-- <a class="dropdown-item emit-j-even" @click="edit(holiday.id)">
                            Editar
                          </a> -->
                          <a class="dropdown-item" @click="remove(holiday.id)">
                            Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Emojis from '@/components/Emojis.vue';
import PageHeader from '@/components/PageHeader.vue';
// import { ToggleButton } from 'vue-js-toggle-button';
import axios from '@/plugins/axios';
import Swal from 'sweetalert2';

export default {
  name: 'Responses',
  components: {
    // InfiniteLoading,
    // Emojis,
    PageHeader,
    // ToggleButton,
  },
  data() {
    return {
      loading: true,
      departments: [],
      holidays: [],
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      axios().get('webchat/holidays').then((response) => {
        this.loading = false;
        console.log('Holidays', response.data);
        this.holidays = response.data;
      }).catch((error) => {
        this.loading = false;
        console.error('Holidays', error);
      });
    },
    remove(id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: 'Deseja deletar esse horário permanentemente. Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          axios().delete(`webchat/holidays/${id}`).then((response) => {
            this.loading = false;
            Swal.fire('Excluído!', 'Horário excluído', 'success');
            this.fetch();
          }, (error) => {
            this.loading = false;
            this.$toast.show({
              title: 'Erro',
              content: error.message,
              type: 'danger',
            });
          });
        }
      });
    },
    edit(id) {
      this.$router.push({ name: 'CreateEditHoliday', params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.qt-block-ui {
  min-height: 200px;
}
</style>
